import { ProductCard, ProductLoader } from 'theme';
var loadedProducts = {};
class WRProductCard extends ProductCard {
  constructor() {
    super();
    this.priceElement = this.querySelector('.js-price__main');
    this.swatches = this.querySelector('fieldset') || null;
    this.productLink = this.querySelector('a[href*="/products/"]');
    this.handle = this.getAttribute('handle');
    this.prefetchInitiated = false;
  }

  connectedCallback() {
    super.connectedCallback();
    this.swatches?.addEventListener(
      'change',
      this.handlePriceUpdate.bind(this)
    );

    // Add hover event listeners for prefetching
    this.addEventListener('mouseenter', this.prefetchProductData);
    this.addEventListener('touchstart', this.prefetchProductData, {
      passive: true,
    });
  }

  prefetchProductData = () => {
    // Only prefetch once per card instance
    if (this.prefetchInitiated || !this.handle) return;

    this.prefetchInitiated = true;

    // Prefetch the product data
    ProductLoader.load(this.handle)
      .then((product) => {
        // Store in the loadedProducts cache
        loadedProducts[this.handle] = product;

        // Optionally prefetch the product page
        if (this.productLink) {
          const linkUrl = this.productLink.getAttribute('href');
          const prefetchLink = document.createElement('link');
          prefetchLink.rel = 'prefetch';
          prefetchLink.href = linkUrl;
          document.head.appendChild(prefetchLink);
        }
      })
      .catch((error) => {
        console.warn(
          `Failed to prefetch product data for ${this.handle}:`,
          error
        );
      });
  };

  handlePriceUpdate = async (event) => {
    const variantId =
      Number.parseInt(event.target.dataset.variantId) || null;

    // Use cached product data if available
    let product;
    if (loadedProducts[this.handle]) {
      product = loadedProducts[this.handle];
    } else {
      product = await ProductLoader.load(this.handle);
      loadedProducts[this.handle] = product; // Cache for future use
    }

    let variant =
      product.variants.find((v) => v.id === variantId) ||
      product.variants.find((v) =>
        v.options.includes(event.target.value)
      ) ||
      null;

    if (variant && this.priceElement) {
      const usdFormatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
      });
      const formattedPrice = usdFormatter
        .format(variant.price / 100)
        .replace('.00', '');
      return (this.priceElement.textContent = formattedPrice);
    }
    return;
  };
}

customElements.get('wr-product-card') ||
  customElements.define('wr-product-card', WRProductCard);
